import { render, staticRenderFns } from "./FullScreenLayout.vue?vue&type=template&id=16200120&"
import script from "./FullScreenLayout.vue?vue&type=script&lang=js&"
export * from "./FullScreenLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16200120')) {
      api.createRecord('16200120', component.options)
    } else {
      api.reload('16200120', component.options)
    }
    module.hot.accept("./FullScreenLayout.vue?vue&type=template&id=16200120&", function () {
      api.rerender('16200120', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/FullScreenLayout.vue"
export default component.exports